(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prodcuts-recommendation"] && !Shopify.designMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    // Target the specific section that triggered the intersection
    const currentSection = entries[0].target;
    observer.unobserve(currentSection);

    const url = currentSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        console.log(html);
        if (recommendations && recommendations.innerHTML.trim().length) {
          currentSection.innerHTML = recommendations.innerHTML;

          const recommended = document.getElementById('recommended-products');

          new Splide(recommended, {
            perPage: 4,
            gap: '1rem',
            pagination: false,
            focus: 0,
           
            breakpoints: {
              1024: {
                perPage: 3,
                gap: '0.7rem',
                
              },
              640: {
                perPage: 2,
                gap: '0.5rem',
                
              },
            },
          }).mount();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  // Run the selection query
  const productRecommendationsSection = document.querySelector('.product-recommendations');

  // ONLY initialize and observe if the element actually exists on the DOM
  if (productRecommendationsSection) {
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
